import { GraphqQlApi } from '@/api/api.js'
import DataSourceBase from './DataSourceBase'
import { signalRApi } from '@/api/signalR'
import { notificationApi } from '@/api/notificationApi'
import { processingApi } from '@/api/processingApi'
import { getEdsApiInstance } from '../../api/edsApi'
import { getQrCodeApiInstance } from '../../api/qrCodeApi'
import moment from 'moment'
import axios from '../../plugins/axios'
import { JsActionApi } from '@/plugins/jsActions/JsActionApi'
import { WidgetsApi } from '@/plugins/widgetsApi/'
import momentDuration from 'moment-duration-format'
import lodash from 'lodash'
import underscore from 'underscore'

export default class DataSourceModel extends DataSourceBase {
  get EdsApi() {
    return this.#getEdsApi()
  }
  get QrCodeApi() {
    return this.#getQrCodeApi()
  }

  #getQrCodeApi = null
  #getEdsApi = null

  constructor(Vue, dataSource) {
    super(Vue, dataSource.$ID)
    
    this.JsActionApi = function () {
      return new JsActionApi({ 
        store: Vue.$store, 
        GraphqQlApi, 
        $t: Vue.$t.bind(Vue),
        SignalRApi: signalRApi,
        NotificationApi: notificationApi,
        ProcessingApi: processingApi,
        getEdsApiInstance,
        getQrCodeApi: getQrCodeApiInstance,
        axios,
        RouterCore: Vue.$routerCore,
        DataSourceCore: Vue.$dataSourceCore,
        $microflowRunner: Vue.$microFlowRunner,
        Moment: moment
      })
    }
    this.WidgetsApi = new WidgetsApi()
    this._dataSource = dataSource
    this.GraphqQlApi = GraphqQlApi
    this.$t = Vue.$t.bind(Vue)
    this.Moment = moment
    this.SignalRApi = signalRApi
    this.NotificationApi = notificationApi
    this.ProcessingApi = processingApi
    this.#getEdsApi = getEdsApiInstance
    this.#getQrCodeApi = getQrCodeApiInstance
    this.Axios = axios
    this.routerCore = Vue.$routerCore
    this.dataSourceCore = Vue.$dataSourceCore
    this.MicroflowApi = Vue.$microFlowRunner
    this.MomentDuration = momentDuration
    this.Lodash = lodash
    this.Underscore = underscore
  }

  callAction(actionName, parameters) {
    //Дэфолтное выражение
    let actionMethodText = this._dataSource.BusinessLogic.CallActionMethod

    const events = this._dataSource?.BusinessLogic?.EventHandlers
    if (events !== undefined && events.length > 0) {
      const currentDataSource = events.find((e) => e.Name === actionName)
      if (currentDataSource && currentDataSource.Text) {
        actionMethodText = currentDataSource.Text
      }
    }
    let callActionMethod = new Function('actionName', 'parameters', actionMethodText)
    callActionMethod.call(this, actionName, parameters)
  }

  setData(data) {
    this.$store.commit(`${this.getStoreModuleName()}/setData`, data)
  }

  setFilters(data) {
    this.$store.commit(`${this.getFiltersModuleName()}/setData`, data)
  }

  getDataSourceById(id) {
    return this.dataSourceCore.GetDataSource(id)
  }

  async refresh(parameters) {
    if (!this._dataSource.BusinessLogic.UseDefaultRefreshMethod) {
      let refreshMethod = new Function('parameters', this._dataSource.BusinessLogic.RefreshMethod)
      refreshMethod.call(this, parameters)
      return
    }
    await this.refreshGenerated(parameters)
  }

  async refreshGenerated(parameters) {
    try {
      this.ProcessingApi.show()

      let params = {}

      if (parameters) {
        params = { ...parameters }
      }

      if (this.getFilters()) {
        params = { ...params, ...this.getFilters() }
      } 
      
      const id = this._dataSource.$ID
      const data = await this.GraphqQlApi.callOperation({ dataSourceId: id }, params)
      this.ProcessingApi.hideAll()
      this.setData(data.data)
    } catch (error) {
      console.error(error)
    } finally {
      this.ProcessingApi.hideAll()
    }
  }
}
